import React, { ChangeEvent, FC, FormEvent, useState } from "react";
import { Icons, Text } from "@evvve/ui-kit";
import { ChatVariant, messengerApi } from "src/store/messenger";
import {
  useGetChatMateComplex,
  useMessengerViewController,
} from "src/close-part/features/Messenger/hooks";
import { nanoid } from "@reduxjs/toolkit";
import { InputMaxLength } from "src/constants";
import { ReactComponent as RestrictedToMessageGray400 } from "./assets/restricted_to_message_gray_400.svg";
import s from "./styles.module.scss";

const MESSAGE_INPUT_ID = "message-input";

type Props = {
  chatVariant?: ChatVariant;
};

const BottomBar: FC<Props> = ({ chatVariant }) => {
  const { chatId } = useMessengerViewController();

  const [inputValue, setInputValue] = useState("");
  const [sendMessageMutation] = messengerApi.useSendMessageMutation();
  const { chatMateProfile } = useGetChatMateComplex({
    skip: chatVariant !== ChatVariant.PRIVATE,
  });

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= InputMaxLength.XXXL_4096) {
      setInputValue(event.target.value);
    }
  };

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (inputValue === "" || !chatId) return;

    sendMessageMutation({
      message: inputValue,
      identifier: nanoid(),
      chat_id: chatId,
    });

    setInputValue("");
  };

  const isRestrictedToMessage =
    chatMateProfile && !chatMateProfile.is_can_start_chat;

  if (isRestrictedToMessage) {
    return (
      <div className={s.restrictedToMessageWrap}>
        <div className={s.icon}>
          <RestrictedToMessageGray400 />
        </div>
        <Text size="m" color="grayscale800">
          {chatMateProfile?.user.first_name} has restricted messages from other users
        </Text>
      </div>
    );
  }

  return (
    <form className={s.root} onSubmit={onSubmit}>
      <label
        htmlFor={MESSAGE_INPUT_ID}
        className={s.inputWapper}
        aria-labelledby="TODO:"
      >
        <input
          type="text"
          id={MESSAGE_INPUT_ID}
          name={MESSAGE_INPUT_ID}
          placeholder="Type your message"
          value={inputValue}
          onChange={onInputChange}
          className={s.input}
          autoComplete="off"
        />
      </label>
      {inputValue !== "" && (
        <button className={s.submitBtn} type="submit" aria-labelledby="TODO:">
          <Icons.Send color="violet600" size="m" />
        </button>
      )}
    </form>
  );
};

export default BottomBar;
